import TenantLogin from 'components/Modals/Login/TenantLogin'
import React from 'react'
import dynamic from 'next/dynamic'

const Navbar = dynamic(() => import('components/Navbar'))

export default function LoginPage() {
    return (
        <>
            <Navbar />
            <div className="w-full login-screen  inline-flex">
                <div className="flex  m-auto  relative loginwrap max-w-7xl mx-auto ">
                    <TenantLogin hide_close_button />
                </div>
            </div>
        </>
    )
}
